import { Form, Formik, useFormikContext } from 'formik';
import React from 'react';
import { connect } from 'react-redux';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate } from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import { Input } from 'reactstrap';
import { Label } from '../../components';
import { searchPolicy } from '../../actions/policy';

export const ReportPolicyListSearch = ({ loading }) => {
  const { setFieldValue, values } = useFormikContext();
  return (
    <Form className='mb-3'>
      <div className='row col-md-12 d-flex flex-md-row flex-sm-column'>
        <div className='form-group col-md-3'>
          <Label>Số hợp đồng</Label>
          <div>
            <Input
              value={values?.policyNumber || ''}
              onChange={(e) => setFieldValue('policyNumber', e.target.value)}
              placeholder='Số hợp đồng'
              inputProps={{ className: 'form-control' }}
            />
          </div>
        </div>
        <div className='form-group col-md-3'>
          <Label>Mốc thời điểm nhắc phí</Label>
          <div>
            <select value={values?.reminderType ?? ""} onChange={(e) => setFieldValue('reminderType', e.target.value)} className='form-control'>
              <option value="PREMIUM_DUE">HĐ hiệu lực sắp đến hạn đóng phí</option>
              <option value="PREMIUM_OVER_DUE">HĐ hiệu lực quá hạn đóng phí</option>
              <option value="LAPSED_IN_7_DAYS">HĐ mất hiệu lực sau 7 ngày</option>
              <option value="LAPSED">HĐ mất hiệu lực và nhắc phí để khôi phục</option>
            </select>
          </div>
        </div>
        <div className='form-group col-md-3'>
          <Label>Tên Khách hàng</Label>
          <div>
            <Input
              value={values?.poName || ''}
              onChange={(e) => setFieldValue('poName', e.target.value)}
              placeholder='Tên Khách hàng'
              inputProps={{ className: 'form-control' }}
            />
          </div>
        </div>
        <div className='form-group col-md-6 custom-premium-due'>
          <fieldset>
            <legend>Ngày đến hạn đóng phí</legend>
            <div className='row col-md-12 d-flex flex-md-row flex-sm-column'>
              <div className='form-group col-md-6' style={{paddingRight: '5px'}}>
                <Label>Từ ngày</Label>
                <div className='div-input-date'>
                  <DayPickerInput
                    format='DD/MM/YYYY'
                    formatDate={formatDate}
                    parseDate={parseDate}
                    placeholder='DD/MM/YYYY'
                    onDayChange={(date) => setFieldValue('fromPremiumDue', date)}
                    value={values?.fromPremiumDue}
                    inputProps={{ className: 'form-control' }}
                  />
                </div>
              </div>
              <div className='form-group col-md-6 pr-0' style={{paddingLeft: '25px'}}>
                <Label>Đến ngày</Label>
                <div className='div-input-date'>
                  <DayPickerInput
                    format='DD/MM/YYYY'
                    formatDate={formatDate}
                    parseDate={parseDate}
                    placeholder='DD/MM/YYYY'
                    onDayChange={(date) => setFieldValue('toPremiumDue', date)}
                    value={values?.toPremiumDue}
                    inputProps={{ className: 'form-control' }}
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <button type='submit' className='btn btn-primary text-uppercase px-4' disabled={loading}>
        Tìm kiếm
      </button>
    </Form>
  );
};

const FormikWrapper = ({ values, onSubmit, loading }) => {
  return (
    <Formik initialValues={values} onSubmit={onSubmit}>
      <ReportPolicyListSearch loading={loading} />
    </Formik>
  );
};

const mapStateToProps = (state) => {
  return {
    values: state?.policy?.condition,
    loading: state?.policy?.loading,
  };
};

const mapDispatchToProps = { onSubmit: searchPolicy };

export default connect(mapStateToProps, mapDispatchToProps)(FormikWrapper);
